import {createContext, useContext, useReducer} from 'react'
import axios from "@plugins/axios"
import {showToast} from "@plugins/toast"
import {navigate} from "@reach/router"

export const initialState = {
	active: true,
	title: '',
	applies_to: 'all_products',
	recommend_to: 'specific_products',
	target_collection: '',
	target_products: [],
	recommended_products: [],
	recommended_collection: '',
	active_discount: false,
	discount: {
		value: 0,
		type: 'PERCENTAGE'
	}
}

const Context = createContext(initialState)

export const ContextProvider = ({children}) => {
	const [state, dispatch] = useReducer((state, action) => {
		switch (action.type) {
			case 'setData':
				return {
					...state,
					...action.payload
				}
			default:
				throw new Error()
		}

	}, initialState)

	return (
		<Context.Provider value={{state, dispatch}}>{children}</Context.Provider>
	)
}

export const useStore = () => useContext(Context)

export const createOffer = (state) => {
	return new Promise((resolve, reject) => {
		axios.post('/pre-purchase', {
			...state
		})
			.then(resolve)
			.catch(reject)
	})
}
export const getOffer = id => {
	return new Promise(resolve => {
		axios.get(`/pre-purchase?ids=${id}`)
			.then(response => {
				console.log(response, 'response')
				const {data} = response.data
				resolve(data && data[0])
			})
			.catch(function (error) {

			})
			.then(resolve)
	})
}
export const updateOffer = (data) => {
	const {_id, ...rest} = data
	return new Promise((resolve, reject) => {
		axios.post(`/pre-purchase/${_id}`, rest)
			.then(response => {
				console.log(response, 'response')
				resolve(response)
			})
			.catch(reject)
			.then(resolve)
	})
}

export const deleteOffers = (ids, redirect = false) => {
	ids = ids.join(',')
	return new Promise((resolve, reject) => {
		axios.get(`/pre-purchase/delete?ids=${ids}`)
			.then(response => {
				console.log(response, 'response')
				if (response && response.status === 200 && response.data.success) {
					showToast({
						message: 'Offer(s) deleted'
					})
					if (redirect) {
						navigate('/pre-purchase')
					} else {
						setTimeout(() => {
							window.location.reload()
						}, 700)
					}
				}
				resolve(response)
			})
			.catch(reject)
			.then(resolve)
	})
}

export const getOffersList = (params, cancelToken) => {
	const newParams = Object.assign({
		limit: 20,
		page: 1
	}, params)
	return new Promise(resolve => {
		axios.get('/pre-purchase', {
			params: newParams,
			cancelToken: cancelToken
		})
			.then(response => {
				console.log(response, 'response')
				resolve(response.data)
			})
			.catch(function (error) {
			})
			.then(resolve)
	})
}
